import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Input } from '../components/Input';
import { Button } from '../components/Button';
import { SocialLoginButton } from '../components/SocialLoginButton';
import { AuthLayout } from '../components/AuthLayout';
import { useAuth } from '../contexts/AuthContext';
export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const {
    login,
    loginWithGoogle,
    resetPassword
  } = useAuth();
  const navigate = useNavigate();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const handleGoogleLogin = async () => {
    setLoading(true);
    try {
      await loginWithGoogle();
      navigate('/');
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const handleResetPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await resetPassword(resetEmail);
      setShowForgotPassword(false);
      setResetEmail('');
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  if (showForgotPassword) {
    return <AuthLayout title="Reset Password" subtitle="Enter your email to receive reset instructions" data-id="element-987">
        <form onSubmit={handleResetPassword} className="space-y-6" data-id="element-988">
          <Input label="Email" type="email" placeholder="hello@example.com" value={resetEmail} onChange={e => setResetEmail(e.target.value)} required data-id="element-989" />

          <Button type="submit" className="w-full" size="lg" disabled={loading} data-id="element-990">
            {loading ? 'Sending...' : 'Send Reset Link'}
          </Button>

          <button type="button" onClick={() => setShowForgotPassword(false)} className="w-full text-center text-sm text-game-purple font-bold hover:underline" data-id="element-991">
            Back to Login
          </button>
        </form>
      </AuthLayout>;
  }
  return <AuthLayout title="Welcome Back!" subtitle="Continue your journey to flow state productivity" data-id="element-992">
      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-993">
        <Input label="Email" type="email" placeholder="hello@example.com" value={email} onChange={e => setEmail(e.target.value)} required data-id="element-994" />
        <Input label="Password" type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} required data-id="element-995" />

        <div className="flex justify-end" data-id="element-996">
          <button type="button" onClick={() => setShowForgotPassword(true)} className="text-sm text-game-purple font-bold hover:underline" data-id="element-997">
            Forgot Password?
          </button>
        </div>

        <Button type="submit" className="w-full" size="lg" disabled={loading} data-id="element-998">
          {loading ? 'Logging in...' : 'Log In'}
        </Button>
      </form>

      <div className="relative my-6" data-id="element-999">
        <div className="absolute inset-0 flex items-center" data-id="element-1000">
          <div className="w-full border-t border-gray-200 dark:border-gray-700" data-id="element-1001"></div>
        </div>
        <div className="relative flex justify-center text-sm" data-id="element-1002">
          <span className="px-2 bg-game-bg-pink dark:bg-[#1a1d29] text-gray-500" data-id="element-1003">
            Or continue with
          </span>
        </div>
      </div>

      <div className="space-y-3" data-id="element-1004">
        <SocialLoginButton provider="google" onClick={handleGoogleLogin} disabled={loading} data-id="element-1005" />
      </div>

      <p className="text-center text-gray-500 dark:text-gray-400 text-sm mt-6" data-id="element-1006">
        Don't have an account?{' '}
        <Link to="/signup" className="text-game-coral font-bold hover:underline" data-id="element-1007">
          Sign Up
        </Link>
      </p>
    </AuthLayout>;
}